import React, { MouseEvent } from 'react';

import { formatDistanceToNowKo } from '../../../../utils/common';
import { close_white_12x12 } from '../../../../utils/common/variables';
import { useHistoryMethod } from '../../../../utils/hook/useHistoryMethod';
import DiaryDotsMenu from '../../diary/diary-detail/components/DiaryDotsMenu';
import CreatorAvatar from '../components/CreatorAvatar';

import { useDiaryShortsContext } from './_DiaryShortsRoot';

const _DiaryShortsHeader = () => {
  const { diary } = useDiaryShortsContext();
  const history = useHistoryMethod();

  const createAtDistance = formatDistanceToNowKo(diary.createdAt);
  const formattedCreateDate =
    createAtDistance === '오늘' ? createAtDistance : `${createAtDistance}전`;

  const handleClickCreator = async (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();

    history.push(`/recipes/creator/${diary.writer.name}?category=diary`);
  };

  return (
    <div className="flex-between fixed inset-x-0 top-0 z-[1] h-64px bg-black/80">
      <button
        onClick={history.back}
        className="flex-center h-64px w-64px"
        type="button"
      >
        <img src={close_white_12x12} alt="close" />
      </button>
      <button
        onClick={handleClickCreator}
        className="flex-between items-center gap-8px"
        type="button"
      >
        <CreatorAvatar
          size={32}
          image={diary.writer.profileImage}
          isCertified={diary.writer.isCertified}
        />
        <h6 className="text-14px font-medium text-white">
          {diary.writer.name} · {formattedCreateDate}
        </h6>
      </button>
      <div className="flex-center h-64px w-64px">
        <DiaryDotsMenu diary={diary} iconTheme="WHITE" />
      </div>
    </div>
  );
};

export default _DiaryShortsHeader;
